export default __webpack_public_path__ + "static/media/closet3-1440w.8f11b471.png";